import { render } from "./Advice.vue?vue&type=template&id=4a1fc7a8&scoped=true"
import script from "./Advice.vue?vue&type=script&lang=js"
export * from "./Advice.vue?vue&type=script&lang=js"

import "./Advice.vue?vue&type=style&index=0&id=4a1fc7a8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1fc7a8"]])

export default __exports__